import { Divider, List, Typography } from '@mui/material';
import MoreOptionsIconButton from 'modules/common/components/buttons/moreOptionsIconButton';
import MoreOptionsItem from 'modules/common/components/moreOptionsItem';
import { ShortcutAction } from 'modules/shortcuts/models';
import React from 'react';

interface IMoreShortcutOptions {
    enabled: boolean;
    onShortcutAction: (shortcutAction: ShortcutAction) => void;
}

export const MoreShortcutOptions: React.FC<IMoreShortcutOptions> = ({
    enabled,
    onShortcutAction
}) => {
    const deleteText = (): JSX.Element =>
        <Typography className="red-text">
            Delete
        </Typography>;
        
    return <React.Fragment>
        <MoreOptionsIconButton buttonDivClassName='shortcut-more-options-icon'>
            <List disablePadding>
                <MoreOptionsItem
                    text="Edit"
                    onClick={() => onShortcutAction(ShortcutAction.EDIT)}
                />
                <MoreOptionsItem
                    text="Move shortcut"
                    onClick={() => onShortcutAction(ShortcutAction.MOVE)}
                />
                <MoreOptionsItem
                    text={enabled ? "Disable" : "Enable"}
                    onClick={() => onShortcutAction(enabled ? ShortcutAction.DISABLE : ShortcutAction.ENABLE)}
                />
                <Divider light />
                <MoreOptionsItem
                    text={deleteText()}
                    onClick={() => onShortcutAction(ShortcutAction.DELETE)}
                />
            </List>
        </MoreOptionsIconButton>
    </React.Fragment>;
};